import React from 'react';

type IAgentIcon = {
  size?: string;
};

const AgentIcon: React.FC<IAgentIcon> = props => {
  const { size = '32' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#E8E8E8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7C18.2133 7 20 8.78667 20 11C20 13.2133 18.2133 15 16 15C13.7867 15 12 13.2133 12 11C12 8.78667 13.7867 7 16 7ZM16 25.9333C12.6667 25.9333 9.72 24.2267 8 21.64C8.04 18.9867 13.3333 17.5333 16 17.5333C18.6533 17.5333 23.96 18.9867 24 21.64C22.28 24.2267 19.3333 25.9333 16 25.9333Z"
        fill="#969696"
      />
      <rect x="22" y="22" width="8" height="8" rx="4" fill="#00BA34" />
      <rect x="22" y="22" width="8" height="8" rx="4" stroke="#001833" strokeWidth="2" />
    </svg>
  );
};

export default AgentIcon;
